import {useEffect} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

const LanguageRedirect = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const [_, lang] = location.pathname.split('/');
        if (!['en', 'uk'].includes(lang)) {
            navigate(`/en${location.pathname}`);
        }
    }, [location, navigate]);

    return null;
};

export default LanguageRedirect;
